module.exports = __webpack_public_path__ + "img/diapositiva-12-1.a5d06865.png";